var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7895 9.41992C20.7895 5.64892 20.7895 3.76292 19.6175 2.59192C18.4465 1.41992 16.5605 1.41992 12.7895 1.41992H8.78946C5.01846 1.41992 3.13246 1.41992 1.96146 2.59192C0.789459 3.76292 0.789459 5.64892 0.789459 9.41992C0.789459 13.1909 0.789459 15.0769 1.96146 16.2479C3.13246 17.4199 5.01846 17.4199 8.78946 17.4199H12.7895C16.5605 17.4199 18.4465 17.4199 19.6175 16.2479C20.2715 15.5949 20.5605 14.7199 20.6875 13.4199M8.78946 13.4199H4.78946M12.7895 13.4199H11.2895M0.789459 7.41992H5.78946M20.7895 7.41992H9.78946",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistory);
export default __webpack_public_path__ + "static/media/paymentHistory.7fe554db0a6d8d19ec83f4c5c43e7375.svg";
export { ForwardRef as ReactComponent };